import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { useWebsocket } from '../../hooks/useWebsocket'
import SimulationList from '../../modules/simulations/SimulationList'
import { addSubscription, removeSubscription } from '../../state/websocket.slice'
import { getWebsocketChannel } from '../../utils/websocket'

function SimulationsPage() {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { subscribeToChannel, unsubscribeFromChannel } = useWebsocket()

  const handleViewSimulation = (simulation) => {
    navigate(`/simulations/${simulation.simulationNumber || simulation.id}`)
  }

  const handleStartSimulation = (simulation) => {
    console.log('Starting simulation:', simulation)
    // The SimulationList component handles the actual start logic
  }

  const handlePauseSimulation = (simulation) => {
    console.log('Pausing simulation:', simulation)
    // The SimulationList component handles the actual pause logic
  }

  const handleStopSimulation = (simulation) => {
    console.log('Stopping simulation:', simulation)
    // The SimulationList component handles the actual stop logic
  }

  useEffect(() => {
    const channelName = getWebsocketChannel().simulationList

    if (channelName) {
      subscribeToChannel(channelName)
      dispatch(addSubscription(channelName))
    }

    return () => {
      if (channelName) {
        unsubscribeFromChannel(channelName)
        dispatch(removeSubscription(channelName))
      }
    }
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="max-w-7xl mx-auto">
      <div className="mb-6 text-left">
        <h1 className="text-2xl font-bold text-neutral-900 dark:text-white mb-2">
          All Simulations
        </h1>
        <p className="text-neutral-600 dark:text-neutral-400">
          Manage and monitor your simulations
        </p>
      </div>

      <SimulationList
        onViewSimulation={handleViewSimulation}
        onStartSimulation={handleStartSimulation}
        onPauseSimulation={handlePauseSimulation}
        onStopSimulation={handleStopSimulation}
      />
    </div>
  )
}

export default SimulationsPage
